import React from "react";
import Select from "react-select";
import { isArray } from "validate.js";
import styles from "./index.module.scss";
const cssErrorColor = "#c54039";
const cssTagBackgroundColor = "#dae3e7";
const textColor = "#58585a";
export default class DropdownNew extends React.Component {
    static defaultProps = {
        title: "",
    };
    constructor(props) {
        super(props);
        this.state = { options: this.getOptions() };
    }
    componentDidUpdate(previousProps) {
        if (previousProps.options !== this.props.options) {
            this.setState({ options: this.getOptions() });
        }
    }
    handleErrors = () => {
        if (this.props.error && this.props.setErrors) {
            this.props.setErrors({});
        }
    };
    getOptions = () => {
        const { filterOptions = () => true } = this.props;
        return (this.props.options ||
            Object.keys(this.props.enum)
                .filter((k) => typeof this.props.enum[k] === "number")
                .map((k) => ({
                value: this.props.enum[k],
                label: k.replaceAll("_", ` `),
            }))
                .filter((element) => filterOptions(element)));
    };
    onChange = (option) => {
        this.props.onChange({
            field: this.props.name,
            option,
        });
    };
    findValue = (options) => {
        if (this.props.value === undefined) {
            return null;
        }
        if (this.props.isMulti) {
            return options.filter(({ value }) => isArray(this.props.value) &&
                this.props.value.includes(value));
        }
        return options.find(({ value }) => value === this.props.value) || null;
    };
    render() {
        const css = {
            container: (provided) => {
                return {
                    ...provided,
                    width: "100%",
                    borderRadius: "8px",
                    maxHeight: "auto",
                };
            },
            valueContainer: (provided) => {
                return {
                    ...provided,
                    maxHeight: "auto",
                    minHeight: "40px",
                    padding: "8px 12px",
                    position: "unset",
                };
            },
            indicatorsContainer: (provided) => {
                return {
                    ...provided,
                    maxHeight: "40px",
                    minHeight: "40px",
                    display: "flex",
                    alignItems: "center",
                };
            },
            singleValue: (provided) => {
                return {
                    ...provided,
                    top: "50%",
                    width: "100%",
                    fontFamily: '"Open Sans", sans-serif',
                    fontSize: "14px",
                    color: "#000000",
                    lineHeight: "20px",
                };
            },
            multiValue: (provided) => {
                return {
                    ...provided,
                    marginRight: "4px",
                    backgroundColor: cssTagBackgroundColor,
                    marginTop: "-0.3vw",
                    maxHeight: "1.5vw",
                    alignItems: "center",
                };
            },
            placeholder: (provided) => {
                return {
                    ...provided,
                    color: this.props.error ? cssErrorColor : "#888f97",
                    top: "50%",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    fontFamily: '"Open Sans", sans-serif',
                    fontSize: "14px",
                };
            },
            indicatorSeparator: (provided) => {
                return {
                    ...provided,
                    maxHeight: "2vw",
                    minHeight: "1vw",
                    display: "none",
                };
            },
            dropdownIndicator: (provided) => {
                return {
                    ...provided,
                    color: "#0eabdb",
                    padding: "8px 12px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "40px",
                    cursor: "pointer",
                };
            },
            option: (provided, state) => {
                return {
                    ...provided,
                    backgroundColor: state.isSelected
                        ? "rgba(14, 171, 219, 0.08)"
                        : state.isFocused
                            ? "rgba(14, 171, 219, 0.04)"
                            : provided.backgroundColor,
                    color: state.isSelected ? "#0eabdb" : provided.color,
                    fontFamily: '"Open Sans", sans-serif',
                    fontSize: "14px",
                    padding: "8px 12px",
                };
            },
            control: (provided) => {
                return {
                    ...provided,
                    maxHeight: "40px",
                    minHeight: "40px",
                    border: "none",
                    borderWidth: "0",
                    boxShadow: "none",
                    "&:hover": {
                        border: "none",
                    },
                    borderRadius: this.props.title.length > 0 ? "0 8px 8px 0" : "8px",
                    padding: 0,
                    backgroundColor: "white",
                    cursor: "pointer",
                };
            },
            menu: (provided) => {
                return {
                    ...provided,
                    position: this.props.relative ? "relative" : "absolute",
                    zIndex: 9999,
                    color: textColor,
                    borderRadius: "8px",
                    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
                    border: "1px solid #ccd4dc",
                    marginTop: "4px",
                };
            },
            menuPortal: (provided) => {
                return {
                    ...provided,
                    zIndex: 9999,
                };
            },
        };
        const { options } = this.state;
        const value = this.findValue(options);
        return (React.createElement("div", { className: `${styles.wrapper} ${this.props.error ? styles.error : ""}` },
            this.props.title.length > 0 ? (React.createElement("div", { className: styles.title }, this.props.title)) : (React.createElement(React.Fragment, null)),
            React.createElement("div", { className: styles.selectWrapper },
                React.createElement(Select, { ...{
                        ...this.props,
                        styles: css,
                        options,
                        value,
                        onChange: this.onChange,
                        isDisabled: this.props.disabled,
                    }, isClearable: false, onFocus: this.handleErrors, menuPortalTarget: document.body, menuPosition: "fixed" }))));
    }
}
